"use strict";
exports.__esModule = true;
exports.getParameters = void 0;
var define_1 = require("codesandbox-import-utils/lib/api/define");
exports.getParameters = define_1.getParameters;
//# sourceMappingURL=define.js.map